var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full",attrs:{"data-category":_vm.index}},[_c('div',{staticClass:"sticky -top-px p-3 text-left font-bold text-base bg-gray-200 dark:bg-gray-800 z-10",class:{
      'bg-green-600 text-white dark:bg-green-600': _vm.campaigns === true,
      'bg-yellow-500 text-white dark:bg-yellow-500': _vm.bestsellers === true,
    }},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('ul',{staticClass:"flex flex-col divide divide-y w-full"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }